import React, { useMemo } from 'react'
import ReactSelect from 'react-select'

import COLORS from '../../config/colors'
import { Intent } from '../../config/intent'

interface OptionProps {
    label?: string
    value: string | number
}

export interface SelectProps {
    /** Array of options for the select */
    options: OptionProps[]
    /** Callback for when an item is selected */
    onChange: (selection: any, action: any) => void
    defaultValue?: any
    /** If you can select multiple items */
    isMulti?: boolean
    /** Changes the border color */
    intent?: Intent
    loading?: boolean
    id?: string
    className?: string
    value: string | string[]
    maxMenuHeight?: number
}

export function Select({
    options,
    onChange,
    isMulti = false,
    intent = Intent.DEFAULT,
    loading = false,
    className = '',
    value,
    maxMenuHeight,
}: SelectProps) {
    const intentColor = COLORS[intent]
    const displayValue = useMemo(() => {
        if (isMulti) {
            //@ts-ignore
            return value?.map(item => {
                return options?.find(option => option.value === item)
            })
        } else {
            return options.find(option => option.value === value)
        }
    }, [value, isMulti, options])

    return (
        <ReactSelect
            value={displayValue}
            className={className}
            options={options}
            isMulti={isMulti}
            onChange={onChange}
            isLoading={loading}
            maxMenuHeight={maxMenuHeight}
            styles={{
                control: provided => ({
                    ...provided,
                    border: `1px solid ${intentColor}`,
                    borderRadius: '0.375rem',
                }),
                valueContainer: provided => ({
                    ...provided,
                    padding: '8px 2.25rem 8px 2.25rem',
                }),
                indicatorSeparator: () => ({
                    display: 'none',
                }),
                indicatorsContainer: provided => ({
                    ...provided,
                    minWidth: 60,
                }),
            }}
        />
    )
}
